import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { DialogContentBase, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { IntlService, load } from '@progress/kendo-angular-intl';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';
import { Item } from 'src/app/models/item.model';
import { Compartimento } from 'src/app/models/compartimento.model';
import { SharingService } from 'src/app/services/sharing.service';


@Component({
    selector: 'app-compartment-form-component',
    templateUrl: './compartment-form.component.html'
})
export class CompartmentFormComponent extends DialogContentBase implements OnInit {
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public formGroup: FormGroup = new FormGroup({});
    public gridView: any[] = [];
    public listaDeArtigos: Array<Item> = [];
    public compartimento: Compartimento = {
        id: 0,
        refArmarioModulo: 0,
        nome: "",
        hmi: false,
        coluna: 0,
        ordem: 0,
        linha: 0,
        linhaSpan: 0,
        tamanho: 0,
        descricaoTamanho: "",
        endereco: "",
        enderecoSecundario: 0,
        canal: "",
        refArtigo: 0,
        descricaoArtigo: "",
        codigoInternoArtigo: "",
        quantidadeDesejada: 0,
        quantidadeAlertaStock: 0,
        compartimentoEstado: {
            id: 0,
            refArmarioModuloCompartimento: 0,
            bloqueado: false,
            avariado: false,
            ocupado: false,
            numeroDeUtilizacoes: 0,
            prioridade: 0,
            refFerramenta: 0,
            descricaoFerramenta: "",
            descricaoTipoFerramenta: "",
            ferramentaBloqueada: false,
            ferramentaAvariada: false,
            descricaoAvariaFerramenta: "",
            refArtigo: 0,
            descricaoArtigo: "",
            codigoInternoArtigo: "",
            stock: 0,
            refAnomalia: 0,
            descricaoAnomalia: ""
        }

    };


    public customMsgService: CustomMessagesService;

    constructor(public msgService: MessageService, private dialogService: DialogService, private sharingService: SharingService, private notificationService: NotificationService, public override dialog: DialogRef, private intl: IntlService, private api: ApiService) {
        super(dialog);
        this.setFormValues();
        this.customMsgService = this.msgService as CustomMessagesService;
        this.placeHolder.nome = this.customMsgService.translate('selecionartag');
    }

    public load() {
        //Request artigos
        this.api
            .getRequest<BaseHttpResponse<Item[]>>("Artigo/GetArtigos")
            .then((data) => {
                this.listaDeArtigos = data.value;

                // Após carregar a lista, verifica se existe um artigo selecionado previamente
                if (this.compartimento.refArtigo !== 0) {
                    const selectedArtigo = this.listaDeArtigos.find(artigo => artigo.id === this.compartimento.refArtigo);
                    if (selectedArtigo) {
                        // Verifica se o controle existe antes de definir seu valor
                        const refArtigoControl = this.formGroup.get('refArtigo');
                        if (refArtigoControl !== null) {
                            refArtigoControl.setValue(selectedArtigo);
                        }
                    }
                }
            })
            .catch((err) => { });

        //Request compartimento
        this.api
            .getRequest<BaseHttpResponse<Compartimento>>("Compartimento/GetCompartimento?idCompartimento=" + this.compartimento.id)
            .then((data) => {
                this.compartimento = data.value;
            })
            .catch((err) => { });
    }


    ngOnInit(): void {
        this.compartimento = this.sharingService.sharingValue;
        this.load();
        this.setFormValues();

    }

    public placeHolder: any = {
        nome: "",
        id: undefined,
    };

    public setFormValues() {
        this.formGroup = new FormGroup({
            nome: new FormControl(this.compartimento?.nome, [Validators.required]),
            refArtigo: new FormControl(this.compartimento.refArtigo != 0 ? this.listaDeArtigos.find(artigo => artigo.id === this.compartimento.refArtigo) : undefined, [Validators.required]),
            quantidadeDesejada: new FormControl(this.compartimento?.quantidadeDesejada, Validators.required),
            quantidadeAlertaStock: new FormControl(this.compartimento?.quantidadeAlertaStock, Validators.required),

        });
    }

    public saveChanges(): void {
        // Marca todos os controles do formulário como tocados para garantir que a validação seja acionada
        this.formGroup.markAllAsTouched();

        // Verifica se o formulário é válido antes de prosseguir
        if (this.formGroup.valid) {

            // Atribui os valores do formulário ao objeto compartimento
            this.compartimento.refArtigo = this.formGroup.value.refArtigo.id;
            this.compartimento.quantidadeDesejada = parseInt(this.formGroup.value.quantidadeDesejada);
            this.compartimento.quantidadeAlertaStock = parseInt(this.formGroup.value.quantidadeAlertaStock);

            // Chama o serviço API para salvar as alterações
            this.api.save<BaseHttpResult>('Compartimento/SaveConfiguracaoCompartimento', this.compartimento).then(res => {
                if (res.ok) {
                    this.notificationService.show({
                        content: this.customMsgService.translate('registoGravadoComSucesso'),
                        animation: { type: 'slide', duration: 500 },
                        position: { horizontal: 'center', vertical: 'bottom' },
                        type: { style: 'success', icon: true },
                        hideAfter: 2000
                    });
                    window.location.reload();


                } else {
                    // Mostra um erro se o pedido não foi bem-sucedido
                    this.notificationService.show({
                        content: res.message,
                        animation: { type: 'fade', duration: 500 },
                        position: { horizontal: 'center', vertical: 'bottom' },
                        type: { style: 'error', icon: true },
                        hideAfter: 4000
                    });
                }
            }).catch(err => {
                // Trata erros de conexão ou outros erros
                this.notificationService.show({
                    content: err,
                    animation: { type: 'fade', duration: 500 },
                    position: { horizontal: 'center', vertical: 'bottom' },
                    type: { style: 'error', icon: true },
                    hideAfter: 4000
                });
            });
        } else {
            // Se o formulário não for válido, pode querer indicar ao usuário que há campos inválidos
            this.notificationService.show({
                content: this.customMsgService.translate('formInvalid'),
                animation: { type: 'fade', duration: 500 },
                position: { horizontal: 'center', vertical: 'bottom' },
                type: { style: 'warning', icon: true },
                hideAfter: 4000
            });
        }
    }

    public cancelChanges(): void {
        this.setFormValues();
    }


}